import RouteContainer from 'containers/RouteContainer';
import Component from './containers/OnlineRehabilitationContainer';

export const path = `${DOCUMENTS_PATH}/onlineRehabilitation`;
export const navigation = {
  name: 'onlineRehabilitation',
  id: 'onlineRehabilitation.title',
  nonControllable: false,
  nonNavigable: true,
  nonCancellable: true,
};

export default RouteContainer(path, Component);
